import React from 'react';
import { useShopRegionDialogGate } from './ShopRegionDialog.controller';
import { LazyShopRegionDialogContent } from './ShopRegionDialogContent.lazy';
import type { ShopRegionDialogGateArgs } from './ShopRegionDialog.types';

// The gate stays synchronous — it is hooks the shop already runs — while the dialog itself, with
// LanguagePickerV2 and its Combobox behind it, only reaches the wire for a shopper who sees it.
export const ShopRegionDialog: React.FC<ShopRegionDialogGateArgs> = props => {
  const { isVisible, ...contentArgs } = useShopRegionDialogGate(props);

  return isVisible ? <LazyShopRegionDialogContent {...contentArgs} /> : null;
};

ShopRegionDialog.displayName = 'ShopRegionDialog';
